export default __webpack_public_path__ + "static/media/PDFINVOICE.f9518d33.png";